import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { QuoteIcon, UsersIcon, ZapIcon, RocketIcon } from 'lucide-react';
export function SocialProofSection() {
  return <section className="w-full py-20 md:py-32 px-4 md:px-5" data-id="element-402">
      <div className="max-w-3xl mx-auto" data-id="element-403">
        <ScrollReveal data-id="element-404">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-center mb-4" data-id="element-405">
            Creadores que ya usan{' '}
            <span className="text-accent" data-id="element-406">Hook Arsenal</span>
          </h2>
          <p className="text-lg text-neutral-400 text-center mb-14 max-w-xl mx-auto" data-id="element-407">
            Resultados reales de personas que dejaron de improvisar.
          </p>
        </ScrollReveal>

        {/* Testimonial cards */}
        <div className="space-y-5" data-id="element-408">
          <ScrollReveal delay={0.05} data-id="element-409">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 relative" data-id="element-410">
              <QuoteIcon className="w-8 h-8 text-accent/15 absolute top-5 right-5" data-id="element-411" />
              <p className="text-lg text-neutral-200 leading-relaxed mb-4 relative" data-id="element-412">
                "Pasé de 200 a 15K views en mi primer Reel con un gancho del
                arsenal. No cambié nada más. Solo el inicio."
              </p>
              <div className="flex items-center gap-2" data-id="element-413">
                <div className="w-1 h-8 rounded-full bg-accent/40" data-id="element-414" />
                <div data-id="element-415">
                  <p className="text-sm font-semibold text-white" data-id="element-416">
                    Creador de contenido
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-417">CDMX</p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.1} data-id="element-418">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 relative" data-id="element-419">
              <QuoteIcon className="w-8 h-8 text-accent/15 absolute top-5 right-5" data-id="element-420" />
              <p className="text-lg text-neutral-200 leading-relaxed mb-4 relative" data-id="element-421">
                "Ya no me quedo en blanco. Abro el PDF, elijo un gancho, y
                grabo. En 5 minutos tengo el inicio listo."
              </p>
              <div className="flex items-center gap-2" data-id="element-422">
                <div className="w-1 h-8 rounded-full bg-accent-light/40" data-id="element-423" />
                <div data-id="element-424">
                  <p className="text-sm font-semibold text-white" data-id="element-425">
                    Coach de negocios
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-426">Monterrey</p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15} data-id="element-427">
            <div className="bg-surface border border-border rounded-2xl p-6 md:p-8 relative" data-id="element-428">
              <QuoteIcon className="w-8 h-8 text-accent/15 absolute top-5 right-5" data-id="element-429" />
              <p className="text-lg text-neutral-200 leading-relaxed mb-4 relative" data-id="element-430">
                "Mis clientes me preguntan cómo hago para que mis Reels
                enganchen tanto. El secreto es este PDF."
              </p>
              <div className="flex items-center gap-2" data-id="element-431">
                <div className="w-1 h-8 rounded-full bg-neon/40" data-id="element-432" />
                <div data-id="element-433">
                  <p className="text-sm font-semibold text-white" data-id="element-434">
                    Emprendedora
                  </p>
                  <p className="text-xs text-neutral-500" data-id="element-435">Guadalajara</p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>

        {/* Credibility stats */}
        <ScrollReveal delay={0.2} data-id="element-436">
          <div className="mt-12 grid grid-cols-3 gap-4" data-id="element-437">
            <div className="text-center bg-surface/60 border border-border rounded-xl py-5 px-3" data-id="element-438">
              <UsersIcon className="w-5 h-5 text-neon mx-auto mb-2" data-id="element-439" />
              <p className="text-xl md:text-2xl font-extrabold text-white" data-id="element-440">
                +1,500
              </p>
              <p className="text-xs text-neutral-500 mt-1" data-id="element-441">creadores</p>
            </div>
            <div className="text-center bg-surface/60 border border-border rounded-xl py-5 px-3" data-id="element-442">
              <ZapIcon className="w-5 h-5 text-accent mx-auto mb-2" data-id="element-443" />
              <p className="text-xl md:text-2xl font-extrabold text-white" data-id="element-444">
                200
              </p>
              <p className="text-xs text-neutral-500 mt-1" data-id="element-445">ganchos probados</p>
            </div>
            <div className="text-center bg-surface/60 border border-border rounded-xl py-5 px-3" data-id="element-446">
              <RocketIcon className="w-5 h-5 text-accent-light mx-auto mb-2" data-id="element-447" />
              <p className="text-xl md:text-2xl font-extrabold text-white" data-id="element-448">
                Día 1
              </p>
              <p className="text-xs text-neutral-500 mt-1" data-id="element-449">listo para usar</p>
            </div>
          </div>
        </ScrollReveal>

        {/* Disclaimer */}
        <ScrollReveal delay={0.25} data-id="element-450">
          <p className="mt-4 text-[10px] text-neutral-600 text-center" data-id="element-451">
            *Resultados dependen de ejecución, nicho y consistencia.
          </p>
        </ScrollReveal>
      </div>
    </section>;
}